import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useState } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import _Heading from '../Heading/index.js';

var _excluded = ["bannerMenu", "children", "imageAltText", "imageUrl", "primaryMessage", "secondaryMessage", "primaryMessageColor", "secondaryMessageColor", "theme"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var StyledBannerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var StyledBannerImage = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n  height: auto;\n  max-width: 100%;\n  width: 100%;\n  min-width: 930px;\n  @media (max-width: 768px) {\n    min-width: 100%;\n  }\n"])));
/*
&& means get a higher specificity without using the dreaded "!important"
see: https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
*/
var StyledHeading = styled(_Heading)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  && {\n    font-weight: 400;\n  }\n  @media (max-width: 768px) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"])));
var StyledBannerMessageContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  left: 3%;\n  position: absolute;\n  top: 5%;\n  @media (max-width: 768px) {\n    position: static;\n  }\n"])));
var StyledPrimaryBannerMessage = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 310px;\n  width: 310px;\n  @media (max-width: 768px) {\n    width: 100%;\n    height: auto;\n  }\n  && {\n    ", " {\n      line-height: 1.2;\n      margin-top: 0;\n      padding: 20px;\n      @media (max-width: 1200px) {\n        font-size: 1.75rem;\n      }\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.white;
}, StyledHeading);
var StyledSecondaryBannerMessage = styled(StyledPrimaryBannerMessage)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  left: 0;\n  width: 160px;\n  height: 160px;\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  top: 0;\n  @media (max-width: 992px) {\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n    height: auto;\n  }\n  && {\n    ", " {\n      font-size: 1.375rem;\n      line-height: 1.75rem;\n      padding: 0;\n      @media (max-width: 992px) {\n        font-size: 1.25rem;\n        line-height: 1.5rem;\n      }\n    }\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.primary;
}, StyledHeading);
var StyledBannerMenuContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  position: relative;\n  margin-top: ", ";\n  width: 94%;\n  @media (max-width: 992px) {\n    margin-top: 0;\n  }\n  @media (max-width: 768px) {\n    margin-top: 0;\n  }\n"])), function (_ref3) {
  var bannerMenuType = _ref3.bannerMenuType;
  return bannerMenuType === 'card' ? '-2%' : '10px';
});
var StyledBannerImageContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  min-height: ", ";\n  overflow: hidden;\n"])), function (_ref4) {
  var isImageLoaded = _ref4.isImageLoaded;
  return isImageLoaded ? 'auto' : '480px';
});
var Banner = function Banner(_ref5) {
  var bannerMenu = _ref5.bannerMenu,
    children = _ref5.children,
    imageAltText = _ref5.imageAltText,
    imageUrl = _ref5.imageUrl,
    primaryMessage = _ref5.primaryMessage,
    secondaryMessage = _ref5.secondaryMessage,
    _ref5$primaryMessageC = _ref5.primaryMessageColor,
    primaryMessageColor = _ref5$primaryMessageC === void 0 ? 'black' : _ref5$primaryMessageC,
    _ref5$secondaryMessag = _ref5.secondaryMessageColor,
    secondaryMessageColor = _ref5$secondaryMessag === void 0 ? 'white' : _ref5$secondaryMessag,
    _ref5$theme = _ref5.theme,
    theme = _ref5$theme === void 0 ? themes["default"] : _ref5$theme,
    rest = _objectWithoutProperties(_ref5, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isImageLoaded = _useState2[0],
    setIsImageLoaded = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledBannerContainer, rest, /*#__PURE__*/React.createElement(StyledBannerImageContainer, {
    isImageLoaded: isImageLoaded
  }, /*#__PURE__*/React.createElement(StyledBannerImage, {
    "data-testid": 'banner-image',
    alt: imageAltText,
    src: imageUrl,
    onLoad: function onLoad() {
      return setIsImageLoaded(true);
    }
  })), /*#__PURE__*/React.createElement(StyledBannerMessageContainer, null, children ? children : /*#__PURE__*/React.createElement(StyledPrimaryBannerMessage, {
    "data-testid": 'primary-banner-message',
    theme: theme
  }, /*#__PURE__*/React.createElement(StyledSecondaryBannerMessage, {
    "data-testid": 'secondary-banner-message',
    theme: theme
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    color: secondaryMessageColor,
    elemType: "h4"
  }, secondaryMessage)), /*#__PURE__*/React.createElement(StyledHeading, {
    theme: themes.secureSite,
    color: primaryMessageColor,
    elemType: "h2"
  }, primaryMessage))), bannerMenu && /*#__PURE__*/React.createElement(StyledBannerMenuContainer, {
    bannerMenuType: bannerMenu.props.bannerMenuType
  }, bannerMenu)));
};
var _Banner = withDefaultTheme(/*#__PURE__*/memo(Banner));

export default _Banner;
export { Banner };
